import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { omit } from '@fabric-app/utils/object/manipulation';

const AbsolutePosition = ({ asChild = false, style, ...props }) => {
  const Comp = asChild ? Slot : "div";
  const absoluteStyle = {
    position: "absolute",
    ...omit(props, [
      "children"
    ]),
    ...style
  };
  return /* @__PURE__ */ jsx(Comp, {
    style: absoluteStyle,
    ...props
  });
};

export { AbsolutePosition };
//# sourceMappingURL=AbsolutePosition.js.map
